import {Component, Inject, AfterContentChecked} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {LocationSet} from '@emm/core/models/location-set.model';
import {AuthFacadeService} from '@emm/auth/services/auth-facade.service';


@Component({
    selector: 'emm-add-child-location-dialog',
    styleUrls: ['./add-child-location-dialog.component.scss'],
    templateUrl: './add-child-location-dialog.component.html'
})
export class AddChildLocationDialogComponent implements AfterContentChecked {

    isReadOnly$ = this.authFacade.isReadOnly$;
    locations: Array<any> = [];
    allLocations: Array<LocationSet> = this.data.allLocations;
    tagExists = false;

    locationListFormGroup = new FormGroup({locationListFormControl: new FormControl()});
    showMainView = true;
    listOfTags = [];
    tagsNotFound: string[] = [];
    listIsValid:boolean;
    errorMessage = '';

    constructor(
        private authFacade: AuthFacadeService,
        public dialogRef: MatDialogRef<AddChildLocationDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any) {}

    ngAfterContentChecked(){
        // tslint:disable-next-line:radix
        this.tagsNotFound.sort((a, b) => parseInt(a) > parseInt(b) ? 1 : -1);
    }

    cancel(): void {
        this.dialogRef.close();
    }



    selectLocation(location): void {
        if(typeof location === 'string'){
            this.locations.push(JSON.parse(location));
        }
        else{
            this.locations.push(location);
        }
    }



    removeLocation(location): void {
        const index = this.locations.indexOf(location);
        if (index >= 0) {
            this.locations.splice(index, 1);
        }
    }



    setTagExists(tagExists): void {
        this.tagExists = tagExists;
    }



    addLocations(): void {
        const locationTags: any[] = [];
        this.locations.forEach(location => {
            locationTags.push({
                tag: location.tag
            });
        });
        this.dialogRef.close(locationTags);
    }

    changeView(): void {
        this.showMainView = !this.showMainView;
    }

    parseLocations (locationsListInitial, )
    {
        let locationsList = '';

        let listIsEmpty = false;

        // Remove all spaces and any starting and ending commas from input string as needed
        switch (locationsListInitial.slice(5, 6)) {
            case ',':
                if (locationsListInitial.charAt(0) === ',') {
                    locationsList = locationsListInitial.slice(0,-1);
                }
                locationsListInitial.trim();
                if (locationsListInitial !== '') {
                    locationsList = locationsListInitial.replace(/\s+/g, '');
                }
                if (locationsList.charAt(locationsList.length-1) === ',') {
                    locationsList = locationsList.slice(0,-1);
                }
                if (locationsList.trim() === '') {
                    listIsEmpty = true;
                }
                break;
            default:
                if (locationsListInitial.charAt(0) === ',') {
                    locationsList = locationsListInitial.slice(0,-1);
                }
                locationsListInitial.trim();
                if (locationsListInitial !== '') {
                    locationsList = locationsListInitial.replace(/\s+/g, ',');
                }
                if (locationsList.charAt(locationsList.length-1) === ',') {
                    locationsList = locationsList.slice(0,-1);
                }
                if (locationsList.trim() === '') {
                    listIsEmpty = true;
                }
                break;
        }

        // Create array of location numbers
        const locs = locationsList.split(',');

        return {locs, listIsEmpty};
    }

    addList(): void {
        this.listIsValid = true;
        const locationsListInitial = this.locationListFormGroup.controls['locationListFormControl'].value;
        const parsedResult = this.parseLocations(locationsListInitial);
        const locs = parsedResult.locs;
        const listIsEmpty = parsedResult.listIsEmpty;

        // Check each location number in array for proper digits
        if(locs.length !== 0 && locs[0] !== ''){
            locs.forEach((element, index) => {
                const regExpression = 'DMA_[0-9]+|[0-9]{5}';
                const listInputCheckResult = new RegExp(regExpression, 'g').test(element);
                if(!listInputCheckResult){
                    this.listIsValid = false;
                    this.errorMessage = `The location identifier ${element} in position ${index+1} is not a proper location number or DMA tag.`;
                    this.locationListFormGroup.controls['locationListFormControl'].setErrors({incorrect: true});
                }
            });
        }

        // Conditionally add processed locations to class level locations
        if(this.listIsValid && !listIsEmpty){
            locs.forEach(t => { this.listOfTags.push(t) });
            this.changeView();
        }

        // If user did not input any location numbers and clicks ok, this will advance them to next view for one at a time inputs
        if(listIsEmpty === true){
            this.changeView();
        }
    }

    addTagsNotFound(tagsNotFound): void {
        this.tagsNotFound = tagsNotFound;
    }

}
